/**
 * WeblabTrackerFilterPanel — placeholder (team selection is embedded in the
 * content toolbar for a compact single-line layout).
 *
 * DashboardShell requires a FilterPanel component, so this returns null.
 * The actual team selector lives in WeblabTrackerContent's toolbar alongside
 * Current Year, Search, and filter controls.
 */

import React from "react";
import type { PluginFilterPanelProps } from "../../types";

const WeblabTrackerFilterPanel: React.FC<PluginFilterPanelProps> = () => {
  return null;
};

export default WeblabTrackerFilterPanel;
